"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withDeleteNodeOnUnwrap = void 0;

var react_1 = __importDefault(require("react"));

var lodash_1 = require("lodash");

var core_1 = require("@bodiless/core");

var withChameleonButton_1 = __importDefault(require("./withChameleonButton"));

var applyChameleon_1 = __importDefault(require("./applyChameleon"));

var withChameleonContext_1 = __importDefault(require("./withChameleonContext"));
/**
 * Ensures that sublist data is purged when sublists are removed.
 *
 * @param nodeKey Location of the child node that will be purged.
 */


var withDeleteNodeOnUnwrap = function withDeleteNodeOnUnwrap(nodeKey) {
  return function (Component) {
    var WithDeleteOnUnwrap = function WithDeleteOnUnwrap(props) {
      var node = core_1.useNode().node;

      var _a = props,
          unwrap = _a.unwrap,
          rest = __rest(_a, ["unwrap"]);

      if (!unwrap) return react_1.default.createElement(Component, __assign({}, props));

      var unwrap$ = function unwrap$() {
        var node$ = nodeKey ? node.child(typeof nodeKey === 'string' ? nodeKey : nodeKey.nodeKey) : node;
        node$.delete();
        if (unwrap) unwrap();
      };

      return react_1.default.createElement(Component, __assign({}, rest, {
        unwrap: unwrap$
      }));
    };

    return WithDeleteOnUnwrap;
  };
};

exports.withDeleteNodeOnUnwrap = withDeleteNodeOnUnwrap;
/**
 * Transforms the wrapped component into a "chameleon".  The chameleon accepts a design and
 * applies one of the design elements to itself depending on the chameleon state, which
 * is stored as bodiless data. A menu option is provided on the local context menu which
 * renders a form allowing the user to select one of the design element alternatives.
 *
 * @param nodeKeys Location where the chameleon state data should be stored.
 * @param defaultData Default chameleon state.
 * @param useOverrides Hook returning overrides for the menu button.
 */

var asBodilessChameleon = function asBodilessChameleon(nodeKeys, defaultData, useOverrides) {
  return lodash_1.flowRight(withChameleonContext_1.default(nodeKeys, defaultData), core_1.ifEditable(withChameleonButton_1.default(useOverrides)), applyChameleon_1.default);
};

exports.default = asBodilessChameleon;